import React from 'react';
import ReactQuill from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';

interface RichTextEditorProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  theme?: 'light' | 'dark';
}

const modules = {
  toolbar: [
    [{ header: [1, 2, 3, false] }],
    ['bold', 'italic', 'underline', 'strike'],
    [{ color: [] }, { background: [] }],
    [{ list: 'ordered' }, { list: 'bullet' }],
    [{ align: [] }],
    ['blockquote', 'code-block'],
    ['link'],
    ['clean']
  ],
  clipboard: {
    matchVisual: false
  }
};

const formats = [
  'header',
  'bold', 'italic', 'underline', 'strike',
  'color', 'background',
  'list', 'bullet',
  'align',
  'blockquote', 'code-block',
  'link'
];

export const RichTextEditor: React.FC<RichTextEditorProps> = ({
  value,
  onChange,
  placeholder = 'Enter detailed description, agenda, or highlights...',
  theme = 'light'
}) => {
  return (
    <div className={`rich-text-editor-wrapper rounded-xl overflow-hidden border ${theme === 'dark' ? 'border-slate-700 bg-slate-800 text-white' : 'border-slate-300 bg-white text-slate-800'}`}>
      <style>{`
        .rich-text-editor-wrapper .ql-toolbar {
          border: none !important;
          border-bottom: 1px solid ${theme === 'dark' ? '#334155' : '#e2e8f0'} !important;
          background: ${theme === 'dark' ? '#1e293b' : '#f8fafc'};
          border-top-left-radius: 0.75rem;
          border-top-right-radius: 0.75rem;
        }
        .rich-text-editor-wrapper .ql-container {
          border: none !important;
          font-family: inherit;
          font-size: 0.875rem;
          min-height: 140px;
          max-height: 350px;
          overflow-y: auto;
          border-bottom-left-radius: 0.75rem;
          border-bottom-right-radius: 0.75rem;
        }
        .rich-text-editor-wrapper .ql-editor {
          min-height: 140px;
          padding: 0.75rem 1rem;
        }
        .rich-text-editor-wrapper .ql-editor.ql-blank::before {
          color: ${theme === 'dark' ? '#94a3b8' : '#94a3b8'};
          font-style: normal;
        }
        ${theme === 'dark' ? `
          .rich-text-editor-wrapper .ql-stroke { stroke: #cbd5e1 !important; }
          .rich-text-editor-wrapper .ql-fill { fill: #cbd5e1 !important; }
          .rich-text-editor-wrapper .ql-picker { color: #cbd5e1 !important; }
          .rich-text-editor-wrapper .ql-picker-options { background-color: #1e293b !important; border-color: #334155 !important; }
        ` : ''}
      `}</style>
      <ReactQuill
        theme="snow"
        value={value || ''}
        onChange={onChange}
        modules={modules}
        formats={formats}
        placeholder={placeholder}
      />
    </div>
  );
};
